export enum SHKeys {
    LONG_TERM_COMPLETE = "LONG_TERM_COMPLETE",
    SHORT_TERM_COMPLETE = "SHORT_TERM_COMPLETE",
    FIRST_HAND_VS_SECOND_HAND_COMPLETE = "FIRST_HAND_VS_SECOND_HAND_COMPLETE",
    VAPOR_COMPLETE = "VAPOR_COMPLETE",
}

export class SecondHandRepo {
    private static innerInstance: SecondHandRepo
    private secondHandCompletedStages: Array<SHKeys> = []

    static get instance() {
        return this.innerInstance || (this.innerInstance = new this())
    }

    static destory() {
        return this.innerInstance = null
    }

    isLongTermComplete(): boolean {
        return this.secondHandCompletedStages.includes(SHKeys.LONG_TERM_COMPLETE)
    }

    setLongTermAsComplete() {
        this.secondHandCompletedStages.push(SHKeys.LONG_TERM_COMPLETE)
    }

    isVaporComplete(): boolean {
        return this.secondHandCompletedStages.includes(SHKeys.VAPOR_COMPLETE)
    }

    setVaporAsComplete() {
        this.secondHandCompletedStages.push(SHKeys.VAPOR_COMPLETE)
    }

    isShortTermComplete(): boolean {
        return this.secondHandCompletedStages.includes(SHKeys.SHORT_TERM_COMPLETE)
    }

    setShortTermAsComplete() {
        this.secondHandCompletedStages.push(SHKeys.SHORT_TERM_COMPLETE)
    }

    isFirstHandVsSecondHandComplete(): boolean {
        return this.secondHandCompletedStages.includes(SHKeys.FIRST_HAND_VS_SECOND_HAND_COMPLETE)
    }

    setFirstHandVsSecondHandComplete() {
        this.secondHandCompletedStages.push(SHKeys.FIRST_HAND_VS_SECOND_HAND_COMPLETE)
    }
}
